import { Component, EventEmitter, Output } from '@angular/core';
import { DocumentsUploaderComponent } from '../documents-uploader/documents-uploader.component';
import { AgentFiveHomeCardsComponent } from '../agent-five-home-cards/agent-five-home-cards.component';
import { ApiFile } from 'app/models/api-response';

@Component({
  selector: 'app-agent-five-home',
  standalone: true,
  imports: [DocumentsUploaderComponent, AgentFiveHomeCardsComponent],
  templateUrl: './agent-five-home.component.html',
  styleUrl: './agent-five-home.component.scss',
})
export class AgentFiveHomeComponent {
  @Output() tabNumberEmitter = new EventEmitter<number>();
  filesToRun: any[] = [];

  // properties to input to the documents uploader component
  showWarningFSChecks: boolean = false;
  showWarningFSvsComp: boolean = false;
  showWarningCYvsPY: boolean = false;

  retrievedFiles: ApiFile[] = [];

  toggleToTabNumber($event: number) {
    this.tabNumberEmitter.emit($event);
  }

  getUploadedFiles($event: any[]) {
    this.filesToRun = [...$event];
  }

  // functions to control the warnings in the docs uploader
  onShowWarningForFSChecks($event: boolean) {
    this.showWarningFSChecks = $event;
  }

  onShowWarningForFSvsComp($event: boolean) {
    this.showWarningFSvsComp = $event;
  }

  onShowWarningForCYvsPY($event: boolean) {
    this.showWarningCYvsPY = $event;
  }

  onSetRetrievedFiles($event: ApiFile[]) {
    this.retrievedFiles = $event;
  }
}
